import { __rest } from '../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useThemeColor } from './useThemeColor.js';

const CheckMarkIcon = forwardRef((_a, ref) => {
    var { checkMarkColor: propCheckMarkColor = 'text.primary' } = _a, props = __rest(_a, ["checkMarkColor"]);
    const getColor = useThemeColor();
    const checkMarkColor = getColor(propCheckMarkColor);
    return (React.createElement(SvgIcon, Object.assign({}, props, { ref: ref, viewBox: "-1 -1 20 20" }),
        React.createElement("g", { "data-name": "Group 23422" },
            React.createElement("g", { "data-name": "Path 15781" },
                React.createElement("path", { d: "M9 17.25C4.45 17.25.75 13.55.75 9S4.45.75 9 .75s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25z", style: { stroke: checkMarkColor, fill: checkMarkColor } }),
                React.createElement("path", { d: "M9 1.5C4.864 1.5 1.5 4.864 1.5 9s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5S13.136 1.5 9 1.5M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0z", style: { fill: checkMarkColor, stroke: checkMarkColor } })),
            React.createElement("path", { "data-name": "Path 15221", d: "M91.438 115.416a.775.775 0 0 1 0 1.024l-4.1 4.544a.586.586 0 0 1-.885.018l-2.173-2.209a.79.79 0 0 1-.048-1.006.591.591 0 0 1 .9-.036l1.722 1.76 3.67-4.1a.6.6 0 0 1 .914.005z", transform: "translate(-78.851 -109.198)", style: { fill: '#fff', stroke: '#fff', strokeWidth: '.2px' } }))));
});

export { CheckMarkIcon };
//# sourceMappingURL=CheckMarkIcon.js.map
